import { Box, Divider, Slide, Stack, Text, useDisclosure } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { ReactNode } from 'react';
import { createPortal } from 'react-dom';

interface IOwnProps {
  titleModalizer: string;
  children?: ReactNode;
}

const Overlay = motion(Box);

const RegistrationAditionInfoMobilePage: React.FC<IOwnProps> = ({ titleModalizer, children }) => {
  const { isOpen, onToggle, onClose } = useDisclosure();
  return (
    <>
      <Text fontSize="12px" color="colorLink" onClick={() => onToggle()} cursor="pointer">
        Detalhes
      </Text>
      {isOpen &&
        createPortal(
          <>
            <Overlay
              position="absolute"
              h="100dvh"
              w="100dvw"
              top={0}
              left={0}
              background="black"
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.6 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2 }}
              onClick={onClose}
              zIndex="100 !important"
              backdropFilter="blur(5px)"
            />
            <Slide direction="bottom" in={isOpen} style={{ zIndex: 101 }}>
              <Box mt="4" bg="white" roundedTop="lg" shadow="xl">
                <Stack px={7}>
                  <Text pt={5} textTransform="uppercase" fontSize="md" textAlign="center" fontWeight="semibold">
                    {titleModalizer}
                  </Text>
                  <Divider my={3} />
                </Stack>
                <Stack maxH="70vh" overflowX="hidden" minH="0">
                  <Stack px={7}>{children}</Stack>
                </Stack>
              </Box>
            </Slide>
          </>,
          document.body,
        )}
    </>
  );
};

export default RegistrationAditionInfoMobilePage;
